<!--<div class="bg-contrast-text">Facilities Page</div>-->
<div>
  @if (pageStore$ | async; as pageStore) {
    <div class="row">
      @if (pageStore['EventsForm'] && pageStore['EventsForm'].IsFave) {
        <div class="col col-12 col-md-6 col-lg-4">
          <a [routerLink]="['/facilities/events']">
            <img src="assets/images/fac-events-1024.jpg" class="img-fluid"><br />
            <!--<i class="icon-color fas fa-calendar-check"></i>-->
            <div class="container">
              <span class="pad-left">Event Support</span>
            </div>
          </a>
        </div>
      }
      @if (pageStore['ParkingForm'] && pageStore['ParkingForm'].IsFave) {
        <div class="col col-12 col-md-6 col-lg-4">
          <a [routerLink]="['/facilities/parking']">
            <img src="assets/images/fac-parking3-1024.jpg" class="img-fluid"><br />
            <!--<i class="icon-color fas fa-parking"></i>-->
            <div class="container">
              <span class="pad-left">Parking Passes</span>
            </div>
          </a>
        </div>
      }
      @if (pageStore['IssueForm'] && pageStore['IssueForm'].IsFave) {
        <div class="col col-12 col-md-6 col-lg-4">
          <a [routerLink]="['/facilities/issue']">
            <img src="assets/images/fac-mccoll-1024.jpg" class="img-fluid"><br />
            <!--<i class="icon-color fas fas fa-exclamation-triangle"></i>-->
            <div class="container">
              <span class="pad-left">Request Facilities Assistance</span>
            </div>
          </a>
        </div>
      }
    </div>
  }
</div>
